import { render, staticRenderFns } from "./ClientBilling.vue?vue&type=template&id=0fbfa59c&"
import script from "./ClientBilling.vue?vue&type=script&lang=js&"
export * from "./ClientBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports